import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const API_BASE_URL = (process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api/v1') + '/chatbot';

let cachedUserId = null;
let cachedPromptsDisabled = null;
let inflightStatusPromise = null;

async function fetchPromptStatus(userId) {
  if (cachedUserId === userId && cachedPromptsDisabled !== null) {
    return cachedPromptsDisabled;
  }

  if (inflightStatusPromise) {
    return inflightStatusPromise;
  }

  inflightStatusPromise = fetch(`${API_BASE_URL}/prompts/${userId}/status`)
    .then((res) => res.json())
    .then((data) => {
      const disabled = Boolean(data.prompts_disabled);
      cachedUserId = userId;
      cachedPromptsDisabled = disabled;
      return disabled;
    })
    .catch(() => {
      cachedUserId = userId;
      cachedPromptsDisabled = false;
      return false;
    })
    .finally(() => {
      inflightStatusPromise = null;
    });

  return inflightStatusPromise;
}

export function invalidateChatbotPromptStatusCache() {
  cachedUserId = null;
  cachedPromptsDisabled = null;
  inflightStatusPromise = null;
}

export function useChatbotPromptStatus() {
  const { userData } = useSelector((store) => store.auth);
  const userId = userData?.id?.toString() || 'default';
  const [promptsDisabled, setPromptsDisabled] = useState(
    cachedUserId === userId && cachedPromptsDisabled !== null ? cachedPromptsDisabled : null
  );

  useEffect(() => {
    if (!userId || userId === 'default') {
      setPromptsDisabled(false);
      return;
    }

    let mounted = true;
    fetchPromptStatus(userId).then((disabled) => {
      if (mounted) {
        setPromptsDisabled(disabled);
      }
    });

    return () => {
      mounted = false;
    };
  }, [userId]);

  const setDisabled = (value) => {
    cachedUserId = userId;
    cachedPromptsDisabled = value;
    setPromptsDisabled(value);
  };

  return {
    promptsDisabled: promptsDisabled ?? false,
    promptsDisabledLoaded: promptsDisabled !== null,
    setPromptsDisabled: setDisabled,
  };
}
